export default __webpack_public_path__ + "landingPageJVRRater.html";